export default "__VITE_ASSET__0IzHpaVg__"